export enum LeaveHistoryUserType {
  Manager = 'Manager',                    // request as manager - see direct reports
  User = 'User',                          // request for other user
  Self = 'Self'                           // request for self
}


export class LeaveHistoryRequest {
  displayOnPage: boolean;                 // if true, summary is displayed on the requested page
  displayOnDialog: boolean;               // if true, summary is displayed on a popup dialog
  userType: LeaveHistoryUserType;         // Self => user's leave history, Manager => leave history of the user's direct report
  userId?: number;                        // if userType == User, userId must be specified
  year?: string;
}

export class LeaveHistory {
  id: number;
  version: number;
  year: string;
  userId: number;
  combinedPool: boolean;
  canAddBeginningBalance?: boolean;

  beginPTOBalance: number;
  ytdPTOTaken: number;
  ytdPTOAccrued: number;
  endingPTOBalance: number;

  beginSickBalance: number;
  ytdSickTaken: number;
  ytdSickAccrued: number;
  endingSickBalance: number;

  beginVacationBalance: number;
  ytdVacationTaken: number;
  ytdVacationAccrued: number;
  endingVacationBalance: number;

  employeeLeaveDetails: LeaveDetail[];
}


export enum LeaveActionType {
  BegBalance = "BEG_BALANCE",
  Taken = "TAKEN",
  Accrued = "ACCRUED",
  Forfeited = "FORFEITED",
  Adjustment = "ADJUSTMENT"
}

export enum CombinedLeaveType {
  // Basic LeaveType
  PTO = "PTO",
  Sick = "SICK",
  Vacation = "VACATION",
  Bereavement = "BEREAVEMENT",

  // Extended LeaveType
  FMLA = "FMLA",
  Jury = "JURY",
  LOA = "LOA",
  Military = "MILITARY",
  LWOP = "LWOP",
  Holiday = "HOLIDAY"
}

export class LeaveDetail {
  id: number;
  version: number;
  actionOn: string;
  actionType: LeaveActionType;
  hours: number;
  leaveType: CombinedLeaveType;
  reason: string;
  leaveHistoryId: number;
  timesheetPeriodId: number;
  includeInCalculations: boolean = true;

  timesheetPeriodAsString: string;
}
